export const OrganizationType = {
  Operator: 'Operator',
  Manufacturer: 'Manufacturer',
  Landlord: 'Landlord',
  OEM: 'OEM',
} as const;

export type OrganizationType =
  (typeof OrganizationType)[keyof typeof OrganizationType];
